// src/components/img/GalerySectionVessels/VesselmaerskVigo.tsx
import React from 'react';
import vesselImage from './maerskVigo.jpeg';

const VesselmaerskVigo: React.FC = () => (
  <img src={vesselImage} alt="Vessel maerskVigo" />
);

export default VesselmaerskVigo;